import _ from 'underscore';

function updateEntitySchemaForAssetId(entitySchema, name) {
  const entitySchemaCopy = entitySchema;

  entitySchemaCopy.properties[name] = {
    name,
    // originalProperty: ...
    property: name,
    operators: ['contains'],
    type: 'string',
    // required: true,
    filterable: true,
  };

  return entitySchemaCopy;
}

function updateOdataOptionsForAssetId(options, { propertyName, entityName, modelName }) {
  const optionsCopy = options || { custom: {} };

  _.extendOwn(optionsCopy.custom, {
    [propertyName]: {
      contains: values => `Model.ResponsiveAd/${entityName}/any(al:al/Asset/${modelName}/Id eq ${values})`,
    },
  });

  return optionsCopy;
}

export const imageProcessors = {
  updateEntitySchema(entitySchema) {
    return updateEntitySchemaForAssetId(entitySchema, 'ResponsiveAdImageId');
  },

  updateOdataOptions(options) {
    return updateOdataOptionsForAssetId(options, {
      propertyName: 'ResponsiveAdImageId',
      entityName: 'Images',
      modelName: 'Model.ImageAsset',
    });
  },
};

export const videoProcessors = {
  updateEntitySchema(entitySchema) {
    return updateEntitySchemaForAssetId(entitySchema, 'ResponsiveAdVideoId');
  },

  updateOdataOptions(options) {
    return updateOdataOptionsForAssetId(options, {
      propertyName: 'ResponsiveAdVideoId',
      entityName: 'Videos',
      modelName: 'Model.VideoAsset',
    });
  },
};
